import React from "react";
import Typography from "@mui/material/Typography";
import EasyClient from "../../Assets/images/PNG/Form_Ai/EasyClient.png";
import { Box, Grid, Container } from "@mui/material";
import "./Second.css";

const Second = () => {
  return (
    <Container style={{ marginTop: "70px" }} id="pricing">
      <Grid container spacing={6}>
        <Grid item xs={12} sm={6} md={6}>
          <img src={"easy.svg"} style={{ width: "100%" }} />
        </Grid>
        <Grid item xs={12} sm={6} md={6}>
          <Box className="second_text">
            <Typography variant="h4" color="initial" fontWeight={600}>
              Easy for clients to fills
            </Typography>
            <Typography
              variant="body1"
              color="secondary"
              sx={{ marginTop: "17px" }}
            >
              Say goodbye to tedious and time-consuming insurance applications.
              Our user-friendly interface and intuitive design make it easy for
              your clients to navigate and fill out their forms.{" "}
            </Typography>
          </Box>
        </Grid>
      </Grid>
    </Container>
  );
};

export default Second;
